module.exports = __webpack_public_path__ + "img/reference-lilalaune.83f1e076.webp";